import { Chat, Sketch } from '../constants'

export const filterInvalidTypes = (files) => {
  let invalid = []
  files = files.filter((v) => {
    v = v.data || v
    if (!Chat.FILETYPES.includes(v.type)) {
      invalid.push(v)
      return false
    }
    return true
  })

  return { valid: files, invalid }
}

export function resizeImage(file) {
  const MAX_DIMENSION = Sketch.MEDIA_SCALE_HEIGHT * 2
  const JPEG_QUALITY = 0.7

  return new Promise((resolve, reject) => {
    const img = new Image()

    img.src = URL.createObjectURL(file)
    img.onload = () => {
      URL.revokeObjectURL(img.src)

      let width = img.width
      let height = img.height

      // Check if resizing is necessary
      if (width <= MAX_DIMENSION && height <= MAX_DIMENSION) {
        // Image is already small enough, return the original file
        resolve(file)
        return
      }

      // Calculate new dimensions
      if (width > height) {
        if (width > MAX_DIMENSION) {
          height *= MAX_DIMENSION / width
          width = MAX_DIMENSION
        }
      } else {
        if (height > MAX_DIMENSION) {
          width *= MAX_DIMENSION / height
          height = MAX_DIMENSION
        }
      }

      // Create canvas and resize
      const canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height

      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, width, height)

      // Convert to Blob
      canvas.toBlob(
        (blob) => {
          resolve(blob)
        },
        'image/jpeg',
        JPEG_QUALITY
      )
    }
    img.onerror = reject
  })
}

export const createObjectURL = (blob) => {
  const crossPlatformUrl = window.URL || window.webkitURL
  return crossPlatformUrl.createObjectURL(blob)
}

export const readImage = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new window.FileReader()

    reader.onerror = reject

    reader.onload = (event) => {
      const blob = new Blob([event.target.result])

      resizeImage(blob, file.name)
        .then((blob) => {
          const resized = new File([blob], name, {
            type: blob.type,
            lastModified: blob.lastModified
          })

          resolve(resized)
        })
        .catch(reject)
    }

    reader.readAsArrayBuffer(file)
  })
}
